import { render, staticRenderFns } from "./SmbSwitch.vue?vue&type=template&id=11fd6e48&scoped=true&"
import script from "./SmbSwitch.vue?vue&type=script&lang=ts&"
export * from "./SmbSwitch.vue?vue&type=script&lang=ts&"
import style0 from "./SmbSwitch.scss?vue&type=style&index=0&id=11fd6e48&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11fd6e48",
  null
  
)

export default component.exports